/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-02-25 14:21:54
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-15 10:52:22
 */
import { axios } from '@/utils/request'

const api = {
    login: '/auth/obtain/',
    logout: '/logout/',
    // get my info
    userOrg: '/user-myorgs/',
    userInfo: '/app/users/myinfo/',
    refresh_token: '/auth/refresh/',

    SendSms: '/account/sms',
    sendVCode: '/auth/send-verify-code/',
    user_logs: '/userlogs/',
}
export default api

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
    return axios({
        url: api.login,
        method: 'post',
        data: parameter,
        noOrg: true,
    })
}

export function logout() {
    return axios({
        url: api.logout,
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })
}

export function sendVCode(parameter) {
    return axios({
        url: api.sendVCode,
        method: 'post',
        data: parameter,
        noOrg: true,
    })
}

export function getSmsCaptcha(parameter) {
    return axios({
        url: api.SendSms,
        method: 'post',
        data: parameter
    })
}

export function getUserOrg(parameter) {
    return axios({
        url: api.userOrg,
        method: 'get',
        params: parameter,
        noOrg: true,
    })
}

export function getInfo(parameter) {
    return axios({
        url: api.userInfo,
        method: 'get',
        params: parameter,
    })
}

export function refreshToken(parameter) {
    return axios({
        url: api.refresh_token,
        method: 'post',
        data: parameter,
        noOrg: true,
    })
}

export function getUserLogs(parameter) {
    return axios({
        url: api.user_logs,
        method: 'get',
        params: parameter,
        noOrg: true,
    })
}




// WEBPACK FOOTER //
// ./src/api/login.js